// extracted by mini-css-extract-plugin
module.exports = {"container":"FilterPopoverSection-module__container--3wL5j","label":"FilterPopoverSection-module__label--1tTvn"};